import makeStyles from "@material-ui/styles/makeStyles";

const styles = makeStyles(theme => ({
	headline: {
		marginBottom: theme.spacing(8),
		overflow: "hidden",
		textAlign: "center",
		"& span": {
			display: "table",
			margin: "0 auto",
			position: "relative",
			"&::before": {
				background: "#AFA08B",
				content: "''",
				height: 1,
				marginRight: theme.spacing(2),
				position: "absolute",
				right: "100%",
				top: "50%",
				width: 1000,
				[theme.breakpoints.up("md")]: {
					marginRight: theme.spacing(4)
				}
			},
			"&::after": {
				background: "#AFA08B",
				content: "''",
				height: 1,
				left: "100%",
				marginLeft: theme.spacing(2),
				position: "absolute",
				top: "50%",
				width: 1000,
				[theme.breakpoints.up("md")]: {
					marginLeft: theme.spacing(4)
				}
			}
		}
	}
}));

export default styles;
